const clone = value => JSON.parse(JSON.stringify(value))
const runTypes = { Data: 'Data', Form: 'data_form', Text: 'data_ev' }
const transientKeys = new Set(['table_datas', 'tableSelectList', 'loadingTable', 'compareDataResult', 'selectedRowIdList', 'isEdit', 'is_selected', 'is_checked', 'showMenu'])

export function inputOverviewSnapshot(flows) {
  return JSON.parse(JSON.stringify(flows.map(item => ({
    id: item.id,
    selectedMultiTableDataList: item.selectedMultiTableDataList || [],
    use_default: Boolean(item.use_default),
  })), (key, value) => transientKeys.has(key) ? undefined : value))
}

export function createInputOverviewModel(workflow, flows) {
  const inputs = flows.filter(item => runTypes[item.type]).map(item => {
    const copy = clone(item)
    copy.type = runTypes[item.type]
    copy.selectedMultiTableDataList = copy.selectedMultiTableDataList || []
    if (copy.type === 'data_ev' && !copy.exampleData?.ev) copy.exampleData = clone(copy.selectedMultiTableDataList[0] || { ev: [['', ''], ['', '']] })
    return copy
  }).sort((a, b) => (a.x - b.x) || (a.y - b.y))
  return { id: workflow.id, name: workflow.name, updated_at: workflow.updated_at, rpa: { rpaFlowList: inputs } }
}

// Only changed input values are returned. Never replace graph nodes, types,
// connections, examples or settings with the run dialog's display model.
export function changedInputOverviewValues(previous, current) {
  const before = new Map(previous.map(item => [String(item.id), item]))
  return current.filter(item => before.has(String(item.id)) && JSON.stringify(before.get(String(item.id))) !== JSON.stringify(item))
}

export function flattenOverviewFolders(nodes, parent = '') {
  return (nodes || []).flatMap(node => {
    const path = parent ? `${parent} / ${node.name}` : node.name
    return [{ value: node.id, text: path }, ...flattenOverviewFolders(node.children, path)]
  })
}
